import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import React from "react";
import TextField from "../TextField";
import Button from "../Button";
import { ActionType, Values } from "../../types";

type Props = {
  actionButtonText: string;
  actionType: ActionType;
  onSubmit: (actionType: ActionType, notes: string, value?: Values | any) => void;
  values?: Values | any;
  isPreApproval?: boolean;
};
const CollectionActionForm = ({
  actionButtonText,
  actionType,
  onSubmit,
  values,
  isPreApproval,
}: Props) => {
  return (
    <Formik
      validateOnBlur={false}
      initialValues={{
        notes: "",
        error: "",
      }}
      validationSchema={Yup.object().shape({
        notes: Yup.string().trim().required("Please enter the notes."),
      })}
      onSubmit={({ error, notes }, actions) => {
        onSubmit(actionType, notes, values);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <form
          onSubmit={handleSubmit}
          noValidate
          className="max-w-lg mx-auto flex flex-col items-center"
        >
          <TextField
            onChange={handleChange}
            autoFocus
            onBlur={handleBlur}
            value={values.notes}
            variant="inner"
            showError={touched.notes && Boolean(errors.notes)}
            required
            name="notes"
            type="textarea"
            id="notes"
            className=""
          />
          <Button
            className="btn bg-gradient border border-gray-70 text-gray-70 font-medium  mb-4 px-12"
            type="submit"
            disabled={isSubmitting}
          >
            {actionButtonText}
          </Button>
        </form>
      )}
    </Formik>
  );
};

export default CollectionActionForm;
